import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceSparkle"><Path d="M8.5 21H7V3H8.5V21Z" fill="currentColor"/><Path d="M16.4004 13L17.4004 15.5996L20 16.5996V17.4004L17.4004 18.4004L16.4004 21H15.5996L14.5996 18.4004L12 17.4004V16.5996L14.5996 15.5996L15.5996 13H16.4004Z" fill="currentColor"/><Path d="M4.5 15H3V9H4.5V15Z" fill="currentColor"/><Path d="M12.75 14.5H11.25V7H12.75V14.5Z" fill="currentColor"/><Path d="M21 14.5H19.5V9H21V14.5Z" fill="currentColor"/><Path d="M17 11.5H15.5V5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceSparkle;
